<template>
  <div class="form-wrapper">
    <!--  Email -->
    <email-field
      class="w-full my-3"
      v-model="email"
      :placeholder="$t('profile.email')"
      :error.sync="emailError"
    />
    <div class="reminder-text">{{ $t('mobileScan.purchase_reminder') }}</div>
    <!--  Save -->
    <div class="btn-wrap">
      <c-button class="my-auto md:mb-10" :confirmed-status="canSave" @click="onClick">
        <span>{{ $t('profile.save') }}</span>
      </c-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EmailField from '@/components/common/Fields/Email.vue';
import CButton from '@/components/common/CButton.vue';
import op from 'object-path';
import ApiActions from '@/modules/api-actions';

export default {
  name: 'UpdateEmail',
  props: {
    show: Boolean,
  },
  components: {
    EmailField,
    CButton,
  },
  computed: {
    ...mapState('user', ['auth', 'me', 'isFetchingRecords', 'feetObjUrl']),
    canSave() {
      return this.email !== '';
    },
    congratsText() {
      return this.$t('mobileScan.payment_succeed');
    },
    congratsDes() {
      return this.$t('mobileScan.payment_succeed_des');
    },
  },
  data() {
    return {
      email: '',
      emailError: false,
    };
  },
  watch: {
    email(nv) {
      if (nv) {
        this.emailError = !this.checkValidEmail(this.email);
      }
    },
  },
  methods: {
    async saveProfile(profile) {
      console.log('[saveProfile]');
      this.$events.startLoading();
      try {
        if (profile.avatar) {
          await ApiActions.user.setAvatar(profile.avatar);
        }
        await ApiActions.user.setProfile(profile);

        this.$emit('close');
      } catch (e) {
        console.log(e.message);
        const message = op.get(e, 'response.data.error.msg', '');
        this.$toasted.global.alert(message);
      } finally {
        this.$events.stopLoading();
      }
    },
    checkValidEmail(email) {
      const emailRegExp = /^\w+((-\w+)|(\.\w+)|(\+\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
      return email.length ? email.length > 3 && emailRegExp.test(email) : true;
    },
    onClick() {
      this.emailError = !this.checkValidEmail(this.email);

      if (!this.emailError) {
        const profile = { ...this.me };
        profile.email = this.email;

        this.saveProfile(profile);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-wrapper {
  @apply w-full flex flex-col items-center justify-start flex-grow;
}

.reminder-text {
  @apply text-xs font-normal text-center;
}

.btn-wrap {
  @apply w-full flex items-center justify-center mt-auto mb-6;
}
</style>
